import * as React from 'react';
import './TextTemplate.css';
import I18n from '../../I18n/I18n/I18n';
import HelpTemplate from '../HelpTemplate/HelpTemplate';
import { getInputDescription } from '../Widgets/wrapSchemaWidget';
import ThemeContext from '../../ThemeContext';
export default function TextTemplate(props) {
  var theme = React.useContext(ThemeContext);
  var className = "_dm-form__text _dm-form__text--".concat(theme, " fr-view _dm__smart-text-break auto-form-static-text");
  var escape = !(props.escape === false);
  var i18n = props.i18n || props.i18nKey;
  var help = props['ui:help'];
  var helpTemplate = /*#__PURE__*/React.createElement(HelpTemplate, {
    description: getInputDescription(help)
  });
  if (i18n) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: i18n,
      escape: escape
    }), help && helpTemplate);
  } else if (escape) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, props.text, help && helpTemplate);
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: props.text
      }
    }), help && helpTemplate);
  }
}